module.exports = __webpack_public_path__ + "static/ribbon_create_calendar-b86f4237d554ecc55c743285a7a8761d.png";